<script setup>
import {computed} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useComponentsStore} from '@/stores/components'
import {useUserStore} from '@/stores/user'
import Button from "@/common/Button.vue"

const props = defineProps({
    tableName: {
        type: String,
        required: true
    }
})

const route = useRoute()
const router = useRouter()
const componentsStore = useComponentsStore()
const userStore = useUserStore()

const component = computed(() => componentsStore.items.find(o => o.tableName === props.tableName))
const user = computed(() => userStore.user)

const show = computed(() => {
    if (!user.value || !component.value) return false

    return (
        user.value.administrator ||
        (user.value.access?.__formAdmin && component.value.navigationGroup === 'Forms')
    )
})

const goToComponentFields = () => {
    router.push({
        name: 'componentFields',
        params: {
            component: route.params.component
        }
    })
}
</script>

<template>
    <Button v-if="show" @click="goToComponentFields">
        <i class="bi-pencil-square me-2"/>
        Fields
    </Button>
</template>